import React, { useEffect } from 'react';
import Nav from '../components/Nav/Nav';
import { useAuth } from '../contexts/AuthContext';
import '../App.css';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
  const navigate = useNavigate();
  const { getRestaurants, listRestaurants, currentUser } = useAuth();

  const MyRestaurant = listRestaurants?.filter((restaurant) => restaurant);

  useEffect(() => {
    if (currentUser) getRestaurants();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div className="one-page">
      <Nav dashboard />

      <div className="main">
        <div className="wrapper-container">
          <div className="wrapper-content">

        <div className="title-wrapper">
              <div className="title-back">
                <p>Dashboard</p>
              </div>
              {MyRestaurant?.length < 1 && <button
                onClick={() => navigate(`/new-shop`)}
                className="button"
              >
                Ajouter une boutique
              </button>}

            </div>

            {MyRestaurant?.length < 1 && (
              <div className="not-found">
                <p>Aucune boutique.</p>
              </div>
            )}

            <div className="wrapper">
              {MyRestaurant?.map((restaurant, index) => (
                <div key={index}>
                  <div
                    className={`card-item ${index === MyRestaurant.length - 1 ? '' : 'border'}`}
                  >
                    <div className="title-wrap">
                      <img className="profile" alt="" src={restaurant.photo} />
                      <div>
                        <p className="title">{restaurant.name}</p>
                        <p className="sub-title">{restaurant.adress}</p>
                      </div>
                    </div>

                    <p className="link" onClick={() => navigate(`/shop/${restaurant.id}`)}>
                      Gérer
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Dashboard;
